import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '../../../shared/filters/auth-guard.service';
import { ValeEstarBemComponent } from './vale-estar-bem.component';
import { GestaoBeneficiarioComponent } from './gestao-beneficiario/gestao-beneficiario.component';


const routes: Routes = [{
  path: '',
  component: ValeEstarBemComponent,
  children: [
    {
      path: 'gestao-beneficiario',
      component: GestaoBeneficiarioComponent,
      canActivate: [AuthGuardService],
      data: {roles: ['BACKOFFIC']},
    },        
  ],

}];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
})
export class ValeEstarBemRoutingModule { }

export const routedComponents = [
  ValeEstarBemComponent,  
  GestaoBeneficiarioComponent, 
];
